import { POST, GET } from './Httpr.js';


export async function setActivityScore(request){
    let url = "score/content";
    let requestData = {
        score: request.score,
        id_type: 1,
        id_content: request.id
    }

    let rsp = await POST(url, requestData);

    return rsp;
}

export async function setLectureScore(request){
    let url = "score/activity";
    let requestData = {
        score: request.score,
        id_type: 1, 
        id_lecture: request.id
    }

    let rsp = await POST(url, requestData);

    return rsp;
}

export async function getActivityScores(request){
    let url = "score/activity";
    let requestData = {
        id: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getScoreById(request){
    let url = "score/getById";
    let requestData = {
        id: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getScoresContentByActivityId(request){
    let url = "score/content";
    let requestData = {
        id_activity: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getAllScoresByModule(request){
    let url = 'score/getAll';
    let requestData = {
        id_course: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}